import axios from 'axios';
import AppResourceCollection
    from '@milestoneslabs/milestones-js-engine/src/Data/AppResourceCollection';
import AddressAppResource
    from '@milestoneslabs/milestones-core-js/src/AppResources/AddressAppResource';
import {capitalize} from './stringHelpers';

export const addressCoreLogicPropertyMatch = async (searchValue, additionalData = {}) => {
    let uri = `${window.env.MILESTONES_API_HOST}/api/v1/corelogic/property`;
    let config = {
        params: {
            input: searchValue
        },
    };

    if (Object.entries(additionalData).length > 0) {
        if (additionalData?.inviteKey) {
            uri = `${window.env.MILESTONES_AUTH_HOST}/invite/corelogic/property/${additionalData.inviteKey}`;
            config.headers = {
                token: additionalData.token,
            };
        }

        if (additionalData?.landingPageUuid) {
            uri = `${window.env.MILESTONES_AUTH_HOST}/landing-page/corelogic/property/${additionalData.landingPageUuid}`;
        }
    }

    try {
        const response = await axios.get(uri, config);
        return response?.data?.data ?? [];
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const standardizeAddress = async (params, isPublic = false) => {
    let uri = `${window.env.MILESTONES_API_HOST}/api/v1/corelogic/standardize`;

    if (isPublic) {
        uri = `${window.env.MILESTONES_AUTH_HOST}/public/corelogic/standardize`;
    }

    try {
        const response = await axios.post(uri, params);
        return response?.data.data ?? {};
    } catch (e) {
        console.error(e);
        throw e;
    }
};

export const addressesToCollection = (addresses) => {
    const collection = new AppResourceCollection('address');

    for (const address of addresses) {
        const deliveryLine = capitalize(address.addressLine1);
        collection.addResource(new AddressAppResource({
            attributes: {
                fullAddress: address.address,
                city: capitalize(address.city),
                country: 'USA',
                state: address.state,
                postalCode: address.zip,
                street: deliveryLine,
                deliveryLine: deliveryLine,
                zip: address.zip,
                corelogicClip: address['clip'],
            },
        }));
    }

    return collection;
};
